import { useRef, useLayoutEffect } from 'react';

const OFFSET = 200;

function useScrollEnd(element: HTMLElement | null, callback: () => void) {
  const previousScrollBottom = useRef(Infinity);
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useLayoutEffect(() => {
    if (element) {
      const handleScroll = (event: Event) => {
        const { offsetHeight, scrollTop, scrollHeight } = event.target as HTMLElement;
        const scrollBottom = scrollHeight - (offsetHeight + scrollTop);
        if (previousScrollBottom.current > OFFSET && scrollBottom < OFFSET) {
          callbackRef.current();
        }

        previousScrollBottom.current = scrollBottom;
      };

      element.addEventListener('scroll', handleScroll);
      return () => {
        if (element) {
          element.removeEventListener('scroll', handleScroll);
        }
      };
    }
  }, [element]);
}

export { useScrollEnd };
